import React, { useEffect, useState } from 'react'
import { RocketLaunchIcon } from "@heroicons/react/20/solid";

import './Home.css'
import { anchorScroll } from '../../helpers/helperFunctions';
import { track } from '../../helpers/track';

// Import pics
import learnFrench from '../../assets/learnFrench.webp'
import ordres from '../../assets/ordres.webp'
import airport from '../../assets/airport.webp'
import patchworkTeam from '../../assets/patchwork-team.webp'
import team2 from '../../assets/team 2.webp'
import microscope from '../../assets/microscope.webp'

// Import components
import ThreeBlocks from '../../components/ThreeBlocks'
import ActiveSlider from '../../components/ActiveSlider'
import MapLocales from '../../components/MapLocales';
import ContactForm from '../../components/ContactForm';
import FeatureBlock from '../../components/FeatureBlock';
import Testimonials from '../../components/Testimonials';

function Home(props) {
    const [scrolledLocaleMain, setScrolledLocaleMain] = useState(0)
    const { isEnglish } = props

    useEffect(() => {
        if (!localStorage.getItem('home')) {
            //Effects
            const bounce = new IntersectionObserver(entries => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('bounce');
                    }
                });
            });

            bounce.observe(document.querySelector('.heroTitle'));
            bounce.observe(document.querySelector('.heroSubtitle'));
            // TOUS les boutons du héro et la ligne de preuve (06/10/2026) :
            // seul le premier CTA était observé — « Postuler » et la note
            // Google restaient figés pendant que le reste s'animait.
            document.querySelectorAll('.heroButton').forEach((el) => bounce.observe(el));
            localStorage.setItem('home', true)
        }
    }, [])


    return (
        <div className='overflow-x-hidden'>

            {/* Home hero with separator — l'argument n°1 (le salaire) est dans
                le titre, pas trois écrans plus bas ; CTAs spécifiques ; preuves
                sous les boutons. */}
            <div className='heroContainer'>
                <div className='heroTextContainer'>
                    <h1 className='heroTitle mb-1 sm:mb-4 md:text-5xl md:mb-3 leading-tight text-3xl w-full'>
                        {isEnglish ? 'DENTIST: €6-20,000 NET / MONTH, FULL SCHEDULE FROM DAY ONE' : 'DENTISTE : 6-20 000 € NETS / MOIS, PLANNING REMPLI DÈS LE JOUR 1'}
                    </h1>
                    <h2 className='heroSubtitle text-lg sm:text-2xl max-w-3xl'>
                        {isEnglish
                            ? 'Join our clinics at the heart of France, 2h from Paris — zero admin work, housing provided on arrival.'
                            : "Rejoignez nos cabinets en cœur de France, à 2 h de Paris — zéro administratif, logement offert à l'arrivée."}
                    </h2>
                    <div className='flex flex-wrap items-center gap-3 mt-8'>
                        <a
                            href="/careers#calculator"
                            onClick={() => { track('hero_cta_click', { cta: 'calculator' }); props.setCurrentScreen && props.setCurrentScreen('/careers') }}
                        >
                            <button className='heroButton flex items-center rounded-xl bg-white px-8 py-3.5 text-sm sm:text-md font-semibold text-gray-900 shadow-lg transition-all duration-200 hover:scale-[1.03] hover:shadow-xl'>
                                {isEnglish ? 'Calculate my salary' : 'Calculer mon salaire'}
                                <RocketLaunchIcon className='w-5 h-5 ml-3' />
                            </button>
                        </a>
                        <button
                            onClick={() => { track('hero_cta_click', { cta: 'apply' }); anchorScroll('#contact-form') }}
                            className='heroButton flex items-center rounded-xl border-2 border-white/80 px-8 py-3 text-sm sm:text-md font-semibold text-white transition-all duration-200 hover:bg-white/10 hover:scale-[1.03]'
                        >
                            {isEnglish ? 'Apply' : 'Postuler'} &rarr;
                        </button>
                    </div>
                    <p className='heroButton mt-5 text-sm sm:text-base text-white/90 font-medium'>
                        <span className='text-amber-300'>★</span> {isEnglish ? '4.8/5 on Google · 3 clinics · 11 treatment rooms' : '4,8/5 sur Google · 3 cabinets · 11 salles de soins'}
                    </p>
                </div>
            </div>
            <div className="custom-shape-divider-bottom-1725632977">
                <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
                    <path d="M0,0V46.29c47.79,22.2,103.59,32.17,158,28,70.36-5.37,136.33-33.31,206.8-37.5C438.64,32.43,512.34,53.67,583,72.05c69.27,18,138.3,24.88,209.4,13.08,36.15-6,69.85-17.84,104.45-29.34C989.49,25,1113-14.29,1200,52.47V0Z" opacity=".25" className="shape-fill"></path>
                    <path d="M0,0V15.81C13,36.92,27.64,56.86,47.69,72.05,99.41,111.27,165,111,224.58,91.58c31.15-10.15,60.09-26.07,89.67-39.8,40.92-19,84.73-46,130.83-49.67,36.26-2.85,70.9,9.42,98.6,31.56,31.77,25.39,62.32,62,103.63,73,40.44,10.79,81.35-6.69,119.13-24.28s75.16-39,116.92-43.05c59.73-5.85,113.28,22.88,168.9,38.84,30.2,8.66,59,6.17,87.09-7.5,22.43-10.89,48-26.93,60.65-49.24V0Z" opacity=".5" className="shape-fill"></path>
                    <path d="M0,0V5.63C149.93,59,314.09,71.32,475.83,42.57c43-7.64,84.23-20.12,127.61-26.46,59-8.63,112.48,12.24,165.56,35.4C827.93,77.22,886,95.24,951.2,90c86.53-7,172.46-45.71,248.8-84.81V0Z" className="shape-fill"></path>
                </svg>
            </div>

            <div className='px-5 md:px-28 mt-12 md:mt-20 text-center'>
                <h3 className="text-md md:text-xl font-semibold leading-7 text-brand-600">{isEnglish ? 'PRIVATE CLINICS IN FRANCE' : 'REJOINDRE NEOMED'}</h3>
                <h2 className="mb-2 md:mb-8 md:mt-1 text-2xl sm:text-3xl font-bold md:text-4xl tracking-tight text-gray-900">
                    {isEnglish ? 'UNLIMITED POSSIBILITIES' : 'DES POSSIBILITES ILLIMITEES'}
                </h2>
                <FeatureBlock
                    text={isEnglish ?
                        "We are currently recruiting dentists and orthodontists for our clinics at the heart of France. Inquire today and take the first step towards a rewarding career in France."
                        :
                        "Nous recrutons actuellement des dentistes et orthodontistes pour nos cabinets en coeur de France, dans l'Indre. Contactez-nous dès maintenant et faites le premier pas vers une carrière plus gratifiante au sein d'une équipe jeune et dynamique."
                    }
                    title={isEnglish ? 'Boost your career' : "Faites décoller votre pratique"}
                    button={isEnglish ? "Who are we  " : 'Qui sommes nous  '}
                    link='/about'
                    img={microscope}
                />
            </div>

            {/* Three items about being a doctor in France */}
            <div className='px-0 md:px-12 mt-14 md:mt-20'>
                <ThreeBlocks isEnglish={isEnglish} />
            </div>

            {/* Our job opportunities */}
            <div className='px-4 sm:px-32 mt-24 sm:mt-32'>
                <div className="relative bg-white py-8 sm:py-12 px-4 sm:px-8 rounded-xl shadow-xl text-center" id="careers">
                    <div className='heroPatternStars absolute bottom-0 left-0 -translate-x-24 translate-y-8 sm:-translate-x-12 sm:translate-y-12 -z-10' />
                    <div className='heroPatternStarsH absolute top-0 right-0 translate-x-32 -translate-y-8 sm:translate-x-12 sm:-translate-y-12 -z-10' />
                    <h3 className="text-md md:text-xl font-semibold leading-7 text-brand-600">{isEnglish ? "CAREERS IN FRANCE" : "CARRIERES EN FRANCE"}</h3>
                    <h2 className="mb-2 md:mb-8 md:mt-1 text-2xl sm:text-3xl font-bold md:text-4xl tracking-tight text-gray-900">
                        {isEnglish ? "WE ARE HIRING" : 'ON RECRUTE'}
                    </h2>
                    {/* Job cards */}
                    <div className='mt-0 sm:mt-12 grid grid-cols-1 sm:grid-cols-2 gap-4'>
                        {[
                            { title: isEnglish ? 'Dentist' : 'Dentiste', location: 'Châteauroux & Déols', salary: isEnglish ? '6,000 – 20,000 EUR net' : '6 000 – 20 000 EUR nets' },
                            { title: isEnglish ? 'Orthodontist' : 'Orthodontiste', location: 'Saint-Maur', salary: isEnglish ? '8,000 – 20,000 EUR net' : '8 000 – 20 000 EUR nets' },
                        ].map((job) => (
                            <div key={job.title} className="rounded-2xl border border-gray-100 bg-white p-6 shadow-md transition-all duration-300 hover:shadow-lg hover:scale-[1.01]">
                                <div className="flex items-center justify-between mb-3">
                                    <h4 className="text-xl font-bold text-gray-900">{job.title}</h4>
                                    <span className="text-xs font-semibold px-3 py-1 rounded-full bg-green-50 text-green-700 ring-1 ring-inset ring-green-700/10">
                                        {isEnglish ? 'Hiring now' : 'On recrute'}
                                    </span>
                                </div>
                                <p className="text-sm text-gray-500">{job.location}</p>
                                <p className="mt-1 text-lg font-bold text-brand-600">{job.salary}<span className="text-sm font-normal text-gray-400"> /{isEnglish ? 'month' : 'mois'}</span></p>
                            </div>
                        ))}
                    </div>

                    {/* Shared conditions */}
                    <div className="mt-6 rounded-2xl bg-gray-50 border border-gray-100 p-6 sm:p-8">
                        <h4 className="text-lg font-bold text-gray-900 mb-4">{isEnglish ? 'What we offer' : 'Ce que nous offrons'}</h4>
                        <dl className="grid grid-cols-2 sm:grid-cols-4 gap-4">
                            {[
                                { name: isEnglish ? 'Revenue Share' : 'Part des Revenus', value: '30+%' },
                                { name: isEnglish ? 'Guaranteed Salary' : 'Salaire Garanti', value: '3 000 EUR' },
                                { name: isEnglish ? 'Work Week' : 'Semaine de travail', value: isEnglish ? '4 days' : '4 jours' },
                                { name: isEnglish ? 'Paid Holidays' : 'Congés Payés', value: isEnglish ? '6 weeks' : '6 semaines' },
                                { name: isEnglish ? 'Free Housing' : 'Logement offert', value: isEnglish ? 'Up to 3 months' : "Jusqu'à 3 mois" },
                                { name: isEnglish ? 'Dedicated Assistant' : 'Assistante dédiée', value: '1' },
                                { name: isEnglish ? 'Admin Work' : 'Administratif', value: '0' },
                                { name: isEnglish ? 'Contract clauses' : 'Clauses contrat', value: '0' },
                            ].map((fact) => (
                                <div key={fact.name} className="text-center sm:text-left">
                                    <dd className="text-xl font-bold text-gray-900">{fact.value}</dd>
                                    <dt className="text-xs text-gray-500 mt-0.5">{fact.name}</dt>
                                </div>
                            ))}
                        </dl>
                        <div className="mt-6 flex items-center justify-center gap-4">
                            <a
                                href="/careers#calculator"
                                onClick={() => props.setCurrentScreen('/careers')}
                                className="inline-flex items-center rounded-xl bg-gray-900 px-5 py-3 text-sm font-semibold text-white shadow-sm transition-all duration-200 hover:bg-brand-600 hover:scale-[1.02]"
                            >
                                {isEnglish ? 'Calculate your salary' : 'Calculez votre salaire'} &rarr;
                            </a>
                            <div onClick={() => anchorScroll('#contact-form')} className="text-sm cursor-pointer font-semibold text-gray-900 hover:text-brand-600 transition-colors">
                                {isEnglish ? 'Apply now' : 'Postuler'} &rarr;
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Map container with separator */}
            <div className='mt-24 sm:mt-40'>
                <MapLocales isEnglish={isEnglish} anchorScroll={anchorScroll} />
            </div>

            {/* Témoignages de praticiens recrutés — la preuve avant le
                process d'expatriation. */}
            <div className='pb-14 sm:pb-24'>
                <Testimonials isEnglish={isEnglish} />
            </div>

            {/* Process of expatriation */}
            <div className="relative px-4 sm:px-20 pb-14 sm:pb-32 pt-20 sm:pt-28 bg-gray-50">
                <div className="py-8 sm:py-20 px-2 sm:px-10 text-center bg-white rounded-2xl shadow-xl border border-gray-100">
                    <h3 className="text-md md:text-xl font-semibold leading-7 text-brand-600">{isEnglish ? 'YOU ARE A FOREIGN DENTIST?' : 'VOUS ÊTES DENTISTE ÉTRANGER?'}</h3>
                    <h2 className="mb-2 md:mb-8 md:mt-1 text-2xl sm:text-3xl font-bold md:text-4xl tracking-tight text-gray-900">
                        {isEnglish ? '5 STEPS TO SUCCESS' : 'EXPATRIEZ-VOUS EN 5 ETAPES'}
                    </h2>
                    <div className='mt-6'>
                        <ActiveSlider
                            setScrolledLocaleMain={setScrolledLocaleMain}
                            scrolledLocaleMain={scrolledLocaleMain}
                            isEnglish={isEnglish}
                            data={[
                                {
                                    title: isEnglish ? "1 | Prepare for your new life" : '1 | Préparez-vous pour votre nouvelle vie',
                                    period: isEnglish ? '1 to 6 months' : '~1 à 6 mois',
                                    text: isEnglish ?
                                        "Let’s discuss the job requirements and our contract structure & benefits. If you don’t speak French yet, we recommend weekly lessons for at least 3 months before moving on to the next step."
                                        :
                                        "Discutons des prérequis du poste ainsi que de votre contrat et avantages. Si vous ne parlez pas encore français, nous vous recommandons des cours hebdomadaires pendant au moins 3 mois avant de passer à l'étape suivante."
                                    ,
                                    backgroundImage: learnFrench,
                                },
                                {
                                    title: isEnglish ? "2 | Register as a doctor in France" : '2 | Enregistrez vous en France',
                                    period: isEnglish ? '~ 2 months' : '~ 2 mois',
                                    text: isEnglish ?
                                        "We’ll gather all the documents required to register you with the local doctors' council in a breeze. You can also use this time to keep perfecting your French in anticipation of the move."
                                        :
                                        "Nous rassemblons tous les documents requis pour vous inscrire auprès du conseil de l'ordre. C'est aussi une période pendant laquelle vous continuez à perfectionner votre français en prévision de votre arrivée."
                                    ,
                                    backgroundImage: ordres,
                                },
                                {
                                    title: isEnglish ? "3 | Discover your new home" : '3 | Découvrez votre chez-vous',
                                    period: isEnglish ? '~ 1 week' : '~ 1 semaine',
                                    text: isEnglish ?
                                        "Time to get settled. We’ll arrange lodging for you and help with admin tasks (bank account, tax registration, schools…). Start your French adventure with peace of mind."
                                        :
                                        "C'est le moment de s'installer. Nous organisons votre hébergement et vous aidons avec toutes vos formalités administratives (compte bancaire, fiscalité, école des enfants…). Démarrez votre aventure française en toute sérénité."
                                    ,
                                    backgroundImage: airport,
                                },
                                {
                                    title: isEnglish ? "4 | Meet your colleagues" : '4 | Rencontrez votre équipe',
                                    period: isEnglish ? '~ 1 week' : '~ 1 semaine',
                                    text: isEnglish ?
                                        "Welcome! Let’s give you a tour and introduce you to the team. We’ll also start briefing you on the specifics of medicine in France (social security refunds, prescriptions...)."
                                        :
                                        "Bienvenue! Nous vous faisons visiter le cabinet et vous présentons à vos nouveaux collègues. Nous vous informons aussi sur les spécificités de la médecine en France (sécurité sociale, ordonances...)."
                                    ,
                                    backgroundImage: patchworkTeam,
                                },
                                {
                                    title: isEnglish ? "5 | Jumpstart your career" : '5 | Faites décoller votre carrière',
                                    period: isEnglish ? 'Game on!' : "C'est parti!",
                                    text: isEnglish ?
                                        "Let’s get started. Our commitment to you is a full agenda, the best support team you can hope for and top-notch equipments. Time to take your career to the next level!"
                                        :
                                        "Commençons. Nous vous garantissons un planning rempli, la meilleure équipe support dont vous pouviez rêver et des équipements modernes. Il est temps de faire passer votre carrière au niveau supérieur!"
                                    ,
                                    backgroundImage: team2,
                                },
                            ]}
                            arrows={true}
                            slides={2}
                        />
                    </div>
                </div>
            </div>
            <div className="custom-shape-divider-top-1725819627">
                <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
                    <path d="M1200 120L0 16.48 0 0 1200 0 1200 120z" className="shape-fill"></path>
                </svg>
            </div>

            {/* Contact and form */}
            <div className='px-2 sm:px-6 mt-14 sm:mt-20'>
                <ContactForm isEnglish={isEnglish} />
            </div>
        </div>
    )
}

export default Home